'use client';

import useIsFocusVisible from '@mui/utils/useIsFocusVisible';
export default useIsFocusVisible;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/useIsFocusVisible.js
// module id = 314
// module chunks = 25